import { useQuery } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'

interface Params {
    studyNumber: string
    organizationId: string
    excludeActivityId?: string
}

export const useCheckStudyNumberQuery = ({ studyNumber, organizationId, excludeActivityId }: Params) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const enabled = !!studyNumber && !!organizationId && !!getTokenSilently && !!isAuthenticated && !isLoading

    return useQuery<{ exists: boolean }>(
        ['checkStudyNumber', studyNumber, organizationId, excludeActivityId],
        async () => {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const params = new URLSearchParams({ studyNumber, organizationId })
            if (excludeActivityId) params.set('excludeActivityId', excludeActivityId)
            const res = await callAPI(
                `${endpoints.checkStudyNumber.url}?${params.toString()}`,
                endpoints.checkStudyNumber.method,
                token
            )
            return res as { exists: boolean }
        },
        {
            enabled,
            staleTime: 0,
            refetchOnWindowFocus: false,
            retry: false,
        }
    )
}
